import { z } from "zod";
import { EspeceSchema } from "./espece.zod";

export const EssenceBaseSchema = z.object({
  count_subject: z.number().int().positive("Le nombre de sujets doit être positif").nullable().optional(),
  nbre_sujet_concerne: z.number().int().positive("Le nombre de sujets concernés doit être positif").nullable().optional(),
  diametre: z.number().int().positive("Le diamètre doit être un nombre positif").nullable().optional(),
  hauteur: z.number().int().positive("La hauteur doit être un nombre positif").nullable().optional(),
  stade_dev: z.string().max(255, "Le stade de développement ne peut pas dépasser 255 caractères").nullable().optional(),
  etat_san_general: z.string().max(255, "L'état sanitaire général ne peut pas dépasser 255 caractères").nullable().optional(),
  risque: z.string().max(255, "Le risque ne peut pas dépasser 255 caractères").nullable().optional(),
  port_arbre: z.string().max(255, "Le port de l'arbre ne peut pas dépasser 255 caractères").nullable().optional(),
  port_arbre_other: z.string().max(255, "L'autre port de l'arbre ne peut pas dépasser 255 caractères").nullable().optional(),
  critere: z.any().nullable().optional(), // JSON field
  critere_other: z.string().max(255, "L'autre critère ne peut pas dépasser 255 caractères").nullable().optional(),
  travaux: z.any().nullable().optional(), // JSON field
  travaux_aucun: z.string().nullable().optional(),
  travaux_other: z.string().nullable().optional(),
  travaux_abattage: z.string().nullable().optional(),
  travaux_demontage: z.string().nullable().optional(),
  travaux_mise_en_securite: z.string().nullable().optional(),
  travaux_taille_sanitaire: z.string().nullable().optional(),
  travaux_dechiffrage: z.string().nullable().optional(),
  travaux_couple_selective: z.string().nullable().optional(),
  date_travaux: z.string().max(255, "La date des travaux ne peut pas dépasser 255 caractères").nullable().optional(),
  date_pro_visite: z.string().max(255, "La date de prochaine visite ne peut pas dépasser 255 caractères").nullable().optional(),
  travaux_com: z.string().max(150, "Le commentaire des travaux ne peut pas dépasser 150 caractères").nullable().optional(),
  travaux_soin: z.string().max(100, "Les soins ne peuvent pas dépasser 100 caractères").nullable().optional(),
  img1: z.string().max(255, "L'URL de l'image 1 ne peut pas dépasser 255 caractères").nullable().optional(),
  img2: z.string().max(255, "L'URL de l'image 2 ne peut pas dépasser 255 caractères").nullable().optional(),
  img3: z.string().max(255, "L'URL de l'image 3 ne peut pas dépasser 255 caractères").nullable().optional(),
  user_edited_date_travaux: z.string().nullable().optional(),
  user_edited_date_pro_visite: z.string().nullable().optional(),
  abattage: z.string().max(150, "L'abattage ne peut pas dépasser 150 caractères").nullable().optional(),
  status_travaux: z.boolean().default(true).optional(),
  espece_id: z.number().int().positive("L'ID de l'espèce doit être un nombre positif"),
  espece: EspeceSchema.optional(),
  epaysage_id: z.number().int().positive("L'ID de l'espace boisé doit être un nombre positif"),
});

export const EssenceSchema = EssenceBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable().optional(),
  updated_at: z.date().nullable().optional(),
});

export const EssenceCreateSchema = EssenceBaseSchema.pick({
  count_subject: true,
  nbre_sujet_concerne: true,
  diametre: true,
  hauteur: true,
  stade_dev: true,
  etat_san_general: true,
  risque: true,
  port_arbre: true,
  port_arbre_other: true,
  critere: true,
  critere_other: true,
  travaux: true,
  travaux_other: true,
  travaux_abattage: true,
  travaux_demontage: true,
  travaux_mise_en_securite: true,
  travaux_taille_sanitaire: true,
  travaux_dechiffrage: true,
  travaux_couple_selective: true,
  date_travaux: true,
  date_pro_visite: true,
  travaux_com: true,
  travaux_soin: true,
  img1: true,
  img2: true,
  img3: true,
  user_edited_date_travaux: true,
  user_edited_date_pro_visite: true,
  abattage: true,
  status_travaux: true,
  espece_id: true,
  epaysage_id: true,
});

export const EssenceUpdateSchema = z.object({
  id: z.number().int().positive(),
  count_subject: z.number().int().positive("Le nombre de sujets doit être positif").nullable().optional(),
  nbre_sujet_concerne: z.number().int().positive("Le nombre de sujets concernés doit être positif").nullable().optional(),
  diametre: z.number().int().positive("Le diamètre doit être un nombre positif").nullable().optional(),
  hauteur: z.number().int().positive("La hauteur doit être un nombre positif").nullable().optional(),
  stade_dev: z.string().max(255).nullable().optional(),
  etat_san_general: z.string().max(255).nullable().optional(),
  risque: z.string().max(255).nullable().optional(),
  port_arbre: z.string().max(255).nullable().optional(),
  port_arbre_other: z.string().max(255).nullable().optional(),
  critere: z.any().nullable().optional(),
  critere_other: z.string().max(255).nullable().optional(),
  travaux: z.any().nullable().optional(),
  travaux_aucun: z.string().nullable().optional(),
  travaux_other: z.string().nullable().optional(),
  travaux_abattage: z.string().nullable().optional(),
  travaux_demontage: z.string().nullable().optional(),
  travaux_mise_en_securite: z.string().nullable().optional(),
  travaux_taille_sanitaire: z.string().nullable().optional(),
  travaux_dechiffrage: z.string().nullable().optional(),
  travaux_couple_selective: z.string().nullable().optional(),
  date_travaux: z.string().max(255).nullable().optional(),
  date_pro_visite: z.string().max(255).nullable().optional(),
  travaux_com: z.string().max(150).nullable().optional(),
  travaux_soin: z.string().max(100).nullable().optional(),
  img1: z.string().max(255).nullable().optional(),
  img2: z.string().max(255).nullable().optional(),
  img3: z.string().max(255).nullable().optional(),
  user_edited_date_travaux: z.string().nullable().optional(),
  user_edited_date_pro_visite: z.string().nullable().optional(),
  abattage: z.string().max(150).nullable().optional(),
  status_travaux: z.boolean().optional(),
  espece_id: z.number().int().positive("L'ID de l'espèce doit être un nombre positif").optional(),
  epaysage_id: z.number().int().positive("L'ID de l'espace boisé doit être un nombre positif").optional(),
});

export const EssenceListResponseSchema = z.object({
  data: z.array(EssenceSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const EssenceResponseSchema = z.object({
  data: EssenceSchema,
  message: z.string().optional(),
});

export const EssenceSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  espece_id: z.number().int().positive().optional(),
  epaysage_id: z.number().int().positive().optional(),
  status_travaux: z.boolean().optional(),
});

export type Essence = z.infer<typeof EssenceSchema>;
export type EssenceCreateInput = z.infer<typeof EssenceCreateSchema>;
export type EssenceUpdateInput = z.infer<typeof EssenceUpdateSchema>;
export type EssenceSelectInput = z.infer<typeof EssenceSelectSchema>;

// Form-specific types for frontend
export type EssenceFormData = Omit<EssenceCreateInput, 'status_travaux'> & {
  status_travaux?: boolean;
};

export type EssenceEditFormData = Omit<EssenceUpdateInput, 'id'>;

// Utility types for different UI states
export type EssenceDisplayItem = Pick<Essence, 'id' | 'status_travaux' | 'stade_dev' | 'etat_san_general'>;
export type EssenceSelectOption = Pick<Essence, 'id' | 'espece_id' | 'epaysage_id'>;
export type EssenceTableItem = Pick<Essence, 'id' | 'hauteur' | 'diametre' | 'status_travaux' | 'stade_dev' | 'etat_san_general' | 'risque'>;

export type EssenceResponse = z.infer<typeof EssenceResponseSchema>;
export type EssenceListResponse = z.infer<typeof EssenceListResponseSchema>;

export const validateEssenceCreate = (data: unknown) => {
  return EssenceCreateSchema.safeParse(data);
};

export const validateEssenceUpdate = (data: unknown) => {
  return EssenceUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateEssenceSelect = (data: unknown) => {
  return EssenceSelectSchema.safeParse(data);
};
